const isLocal = false;

let _HELPDESK_SERVICE_URL;
let _HELPDESK_SOCKET_URL;
let _UCP_URL;
let _USER_MANGER_URL;
let _FETCH_TEAM;
let _AUDIO_URL = 'https://s3-us-west-2.amazonaws.com/richpanel-assets/audio';
const env = process.env.VUE_APP_STAGE;

if (isLocal) {

    _HELPDESK_SERVICE_URL = 'http://localhost:9005/helpdesk';
    _HELPDESK_SOCKET_URL = 'http://localhost:9006';
    _UCP_URL = 'http://localhost:9003/ucp';

} else if (env === 'development') {

    _HELPDESK_SERVICE_URL = 'https://ws-dev.richpanel.com/tenant/srv-helpdesk';
    _HELPDESK_SOCKET_URL = 'https://ws-dev.richpanel.com';
    _UCP_URL = 'https://ws-dev.richpanel.com/ucp';
    _USER_MANGER_URL = 'https://ws-dev.richpanel.com/users';
    _FETCH_TEAM = 'https://ws-dev.richpanel.com/tenant/teams'; 

} else if (env === 'production') {

    _HELPDESK_SERVICE_URL = 'https://ws.richpanel.com/tenant/srv-helpdesk';
    _HELPDESK_SOCKET_URL = 'https://ws.richpanel.com';
    _UCP_URL = 'https://ws.richpanel.com/ucp';
    _USER_MANGER_URL = 'https://ws.richpanel.com/users';
    _FETCH_TEAM = 'https://ws.richpanel.com/tenant/teams'; 
}

export const WEBSOCKET_ENDPOINT = '/websocket/socket.io';
export const WEBSOCKET_SERVER_NAMESPACE = '/customer';
export const HELPDESK_SERVICE_URL = _HELPDESK_SERVICE_URL;
export const HELPDESK_SOCKET_URL = _HELPDESK_SOCKET_URL + WEBSOCKET_SERVER_NAMESPACE;
export const UCP_URL = _UCP_URL;
export const USER_MANGER_URL = _USER_MANGER_URL;
export const FETCH_TEAM = _FETCH_TEAM;
export const AUDIO_URL = _AUDIO_URL;